import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/production/delivery_container/list_containers/${producer_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchContainers(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/production/delivery_container/list_containers/${producer_id}/fetch_containers/${agro_exporter_process_id}`
    );
  }
};
